export class BaseError extends Error {
    public readonly originalError?: Error | unknown;
    public readonly timestamp: Date;

    constructor(message: string, originalError?: Error | unknown) {
        super(message);
        this.originalError = originalError;
        this.timestamp = new Date();

        if (originalError instanceof Error && originalError) {
            this.stack = originalError.stack;
        }
    }

    getDetails(): Record<string, unknown> {
        return {
            name: this.name,
            message: this.message,
            timestamp: this.timestamp.toLocaleString('ja-JP'),
            stack: this.stack,
            originalError: this.originalError,
        };
    }
}
